export default __webpack_public_path__ + "f1e445fda962fe0e35bff7948ae7ddee.svg";